<template>
  <div class="relative shadow-sm rounded-full hover:shadow-lg transition duration-150" :class="[useSize]">
    <div
      class="w-full h-full rounded-full overflow-hidden text-center flex items-center bg-gray-200"
    >
      <img
        v-if="src"
        :src="src"
        :alt="alt"
        class="object-cover object-center w-full h-full"
      />
      <span class="bg-primary-100 text-primary w-full h-full font-bold flex items-center justify-center" v-else-if="name">
          {{ nameInitials }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "Avatar",
  inheritAttrs: false,
  props: {
    src: {
      default: null,
      type: String,
      required: false,
    },
    size: {
      default: 10,
      type: Number,
      required: false,
      validator: (value) => {
        return [10, 12, 16, 24, 32, 48, 64].includes(value);
      },
    },
    alt: {
      default: "avatar",
      type: String,
    },
    name: {
      type: String,
      required: false
    }
  },
  computed: {
    nameInitials() {
        var names = this.name.split(' '),
            initials = names[0].substring(0, 1).toUpperCase();
        
        if (names.length > 1) {
            initials += names[names.length - 1].substring(0, 1).toUpperCase();
        }
        return initials;
    },
    useSize() {
      const size = this.size;
      if (size === 10) {
        return "w-10 h-10";
      } else if (size === 12) {
        return "w-12 h-12";
      } else if (size === 16) {
        return "w-16 h-16";
      } else if (size === 24) {
        return "w-24 h-24";
      } else if (size === 32) {
        return "w-32 h-32";
      } else if (size === 48) {
        return "w-48 h-48";
      } else {
        return "w-64 h-64";
      }
    },
  },
};
</script>
